module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35fed5da5aff896f6ea9d5d3ffc06c05.gif";